/** Spatial focus movement for arrows, D-pad and stick: pure, on plain rectangles. */
export type Dir = 'up' | 'down' | 'left' | 'right';
export interface Box { x: number; y: number; w: number; h: number }

const VEC: Record<Dir, [number, number]> = { up: [0, -1], down: [0, 1], left: [-1, 0], right: [1, 0] };

/** Index of the nearest box in `dir` from `from` (centre to centre, sideways offset costs double), or -1. */
export function nextFocus(boxes: readonly Box[], from: number, dir: Dir): number {
  const a = boxes[from];
  if (!a) return boxes.length ? 0 : -1;
  const [dx, dy] = VEC[dir];
  const ax = a.x + a.w / 2, ay = a.y + a.h / 2;
  let best = -1, bestCost = Infinity;
  boxes.forEach((b, i) => {
    if (i === from) return;
    const vx = b.x + b.w / 2 - ax, vy = b.y + b.h / 2 - ay;
    const along = vx * dx + vy * dy;
    if (along <= 1) return;
    const across = Math.abs(vx * dy - vy * dx);
    const cost = along + 2 * across;
    if (cost < bestCost) { bestCost = cost; best = i; }
  });
  return best;
}
